export const tagsEndPoints = {
  getList: (queryString: string) => `/tags/list${queryString}`,
  create: () => '/tags/create',
  update: (id: string) => `/tags/update/${id}`,
  getById: (id: string) => `/tags/getById/${id}`,
  delete: (id: string) => `/tags/delete/${id}`,
  toggleActive: (id: string) => `/tags/activate/${id}`,
};
